// @flow

export { LoadingPaymentPage } from './loading-payment';
export { OpenedPaymentPage } from './opened-payment';
export { ConfirmedPaymentPage } from './confirmed-payment';
export { PendingPaymentPage } from './pending-payment';
